import { labeled, stringRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    absLendingPurposeCode: Joi.object().keys({
      id: stringRequired(Joi, 1, 32).label(labeled(label, 'ABS Lending purpose code'))
    })
  });

export default {
  schema
};
